import _ from 'underscore'
import Config from '../config'

class Utils {
  static getYear () {
    return new Date().getFullYear()
  }

  static isIOS () {
    return /iP(hone|od|ad)/.test(navigator.userAgent)
  }

  static isIPhone () {
    return /iP(hone|od)/.test(navigator.userAgent)
  }

  static isIPad () {
    return /iPad/.test(navigator.userAgent)
  }

  static isAndroid () {
    return /Android/.test(navigator.userAgent)
  }

  static isYuanTiku () {
    return /YuanTiKu/i.test(navigator.userAgent) && !/YuanTiKuEmbed/i.test(navigator.userAgent)
  }

  static isYuanFuDao () {
    return /YuanFuDao|YuanTiKuEmbed/i.test(navigator.userAgent)
  }

  static isYuanTiKuEmbed () {
    return /YuanTiKuEmbed/i.test(navigator.userAgent)
  }

  static isYuanSouTi () {
    return /YuanSouTi/i.test(navigator.userAgent)
  }

  static isApp () {
    return Utils.isYuanTiku() || Utils.isYuanFuDao() || Utils.isYuanSouTi() || Utils.isYuanTiKuEmbed()
  }

  static isWechat () {
    return /micromessenger/i.test(navigator.userAgent.toLowerCase())
  }

  static isQQ () {
    return /QQ/i.test(navigator.userAgent)
  }

  static isWeibo () {
    return /weibo/i.test(navigator.userAgent.toLowerCase())
  }

  static getAppId () {
    return Utils.isYuanSouTi() ? 201 : Utils.isYuanTiku() ? 101 : 0 // from web
  }

  static getAppVersion () {
    const UA_REGEX = /\s+(YuanTiKu|YuanFuDao|YuanSouTi)\/(\d+\.\d+\.\d+)(\s+|$)/i
    const ua = window.navigator.userAgent
    let matches = ua.match(UA_REGEX)
    return matches ? matches[2] : ''
  }

  static queryConfig () {
    return {
      _productId: 241,
      _appId: Utils.getAppId()
    }
  }

  static extendQuery (query) {
    return _.extend(query || {}, Utils.queryConfig())
  }

  static verifyPhone (phone) {
    return /^1[3-9]\d{9}$/.test(phone)
  }

  static verifyVerificationCode (code) {
    return String(code).length === 6
  }

  static isOnline () {
    return navigator.onLine
  }

  static navigateToYuanSouTi () {
    window.location = `https:${Config.SOLAR_HOST}/app-download`
  }

  static getUrlSchemaPrefix () {
    return Utils.isIPad() ? 'solar-ipad://' : 'solar://'
  }

  static getQuestionDetailUrl (token, isNew) {
    return `${Utils.getUrlSchemaPrefix()}solar/questionDetail?token=${token}&type=2&authType=10&isShareInvite=${!!isNew}`
  }

  static getOpenWebViewUrl (url) {
    return `${Utils.getUrlSchemaPrefix()}openWebView?url=${url}`
  }

  static addFrog (frog, url, params) {
    let paramsList = []
    const appId = Utils.queryConfig()._appId
    paramsList.push(`appId=${appId}`)
    Object.keys(params).forEach(function (key) {
      if (key && params[key]) {
        paramsList.push(`${key}=${params[key]}`)
      }
    })
    frog.add(`${url}?${paramsList.join('&')}`)
  }

  static getParam (key) {
    let search = window.location.search
    if (search) {
      search = search.substring(1)
      let params = search.split('&')
      for (let i = 0; i < params.length; i++) {
        let temp = params[i].split('=')
        if (temp[0] === key) {
          return temp[1]
        }
      }
    }
    return null
  }

  static preventDefault (e) {
    if (!window.ifDisableScroll) {
      return
    }
    if (!e.target.className || e.target.className.indexOf('scrollable') === -1) {
      e.preventDefault()
    }
    e.stopPropagation()
  }

  static enableScroll () {
    if (!Utils.isIOS() || !Utils.isAndroid()) {
      document.body.style.overflow = ''
    }
    window.ifDisableScroll = false
    window.removeEventListener('scroll', Utils.preventDefault)
    window.removeEventListener('touchmove', Utils.preventDefault)
  }

  static disableScroll () {
    if (!Utils.isIOS() || !Utils.isAndroid()) {
      document.body.style.overflow = 'hidden'
    }
    window.ifDisableScroll = true
    window.addEventListener('scroll', Utils.preventDefault, {passive: false})
    window.addEventListener('touchmove', Utils.preventDefault, {passive: false})
  }

  static fixAutofocus () {
    document.querySelector('input[autofocus]').focus()
  }
}

export default Utils



// WEBPACK FOOTER //
// ./src/utils/Utils.js